import client from './client';

export const uploadDoc = (formData) =>
  client.post('/api/history/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);

export const listDocs = (params) =>
  client.get('/api/history/docs', { params }).then(r => r.data);

export const getDoc = (id) =>
  client.get(`/api/history/docs/${id}`).then(r => r.data);

export const reprocessDoc = (id) =>
  client.post(`/api/history/docs/${id}/reprocess`).then(r => r.data);

export const deleteDoc = (id) =>
  client.delete(`/api/history/docs/${id}`).then(r => r.data);

export const searchKb = (body) =>
  client.post('/api/history/search/kb', body).then(r => r.data);

export const searchRepo = (body) =>
  client.post('/api/history/search', body).then(r => r.data);

export const promoteSuggest = (body) =>
  client.post('/api/history/promote/suggest', body).then(r => r.data);

export const promote = (body) =>
  client.post('/api/history/promote', body).then(r => r.data);
